 
<div class="container">
  <!-- Low performance  Medium performance High performance-->
<div class="pt-10"> 
    <ion-row class="center-content">
      <ion-col size-sm="12" size-md="6" size-lg="10" size-xs="12">
        <ion-row class="borderbottomForTab">
          <ion-col size-sm="10" size-md="9" size-lg="2" size-xs="10" class="mb-10">
            <div > 
              <mat-form-field class="w-100 mat-height40 mat-input-style float-right" >
                <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                  (selectionChange)="selectedYearForDashboard(selectedYearForCompetency)">
                  <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                    {{sharedService.transformYearToFyFormat(item.year)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </ion-col> 
        </ion-row>
      </ion-col>
    </ion-row>
  </div>

  <ion-row>
    <ion-col size="12" >
      <span *ngIf="!bandNotFound" class="regular fs-15 ml-10" style="color: #E94848;">The Question is not set for you .</span>
      <div class="performance-summary" *ngIf="bandNotFound && emptyDepartment == 1 && performancePotentialLength == 9">
        <ion-row>
          <ion-col  *ngFor="let item of lowMediumHighPerformanceData">
            <div class="summary-card">
              <h4>{{ item.label }}</h4>
              <div  (click)="openEmployeeTooltip(value)" *ngFor="let value of item.values" class="fixed-width  clickable"   >
                <span  [ngClass]="value.cssClassText">
                  {{ value.category }}
                  <span class="score">-
                    {{ value.count }}
                  </span>
                </span>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </div>
    </ion-col>
  </ion-row>


  <span *ngIf="emptyDepartment == 0 " class="regular fs-15 ml-10" style="color: #E94848;">Your Department is not set in employee master</span>
     <span *ngIf="performancePotentialLength != 9" class="regular fs-15 ml-10" style="color: #E94848;">Setup not completed</span>
     <div class="card" style="margin-top: 20px;" id="nineBoxDash" *ngIf="bandNotFound && emptyDepartment == 1  && performancePotentialLength == 9">
      <h4 class="mt-20 ml-10">Performance vs Potential</h4>
      <ion-row class="m-10" style="margin-bottom: 20px;">
        <ion-col size="3">
          <ng-multiselect-dropdown class="w250 ml-10 mat mat-height40 mat-input-style"
            [placeholder]="'Select Department' + (selectedCount > 1 ? ' +' + (selectedCount - 1) : '')"
            [settings]="dropdownSettings"
            [data]="getDepartmentsList"
            [(ngModel)]="selectedPerformanceDepartments" 
            (onSelect)="getSelectedPerformanceVsPotential()"
            (onDeSelect)="getDeSelectedPerformanceVsPotential()"
            (onSelectAll)="selectAllPerformanceVsPotential()"
            (onDeSelectAll)="onDeSelectAllPerformanceVsPotential()">
          </ng-multiselect-dropdown>
        </ion-col>
    
        <ion-col size="3">
          <ng-multiselect-dropdown class="w250 ml-10 mat mat-height40 mat-input-style"
            [placeholder]="'Select Band' + (selectedCountForBand > 1 ? ' +' + (selectedCountForBand - 1) : '')"
            [settings]="bandDropdownSettings"
            [data]="bandListForPerformanceVsPotential"
            [(ngModel)]="selectedperformancesBands"
            (onSelect)="onPerformanceBandSelect()"
            (onDeSelect)="onperformanceBandDeSelect($event)"
            (onSelectAll)="onSelectAllPerformanceBands($event)"
            (onDeSelectAll)="onDeSelectAllPerformanceBands()">
          </ng-multiselect-dropdown>
        </ion-col>
    
        <ion-col size="3">
          <ng-multiselect-dropdown class="w250 ml-10 mat mat-height40 mat-input-style"
            [placeholder]="'Select Employee' + (selectedCountForEmployee > 1 ? ' +' + (selectedCountForEmployee - 1) : '')"
            [settings]="employeeDropdownSettings"
            [data]="arrEmployeesReport"
            [(ngModel)]="selectedPerformanceEmployee"
            (onSelect)="onPerformanceEmployeeSelect()"
            (onDeSelect)="onPerformanceEmployeeDeSelect()"
            (onSelectAll)="onSelectAllPerformanceEmployees($event)"
            (onDeSelectAll)="onDeSelectAllPerformanceEmployees()">
          </ng-multiselect-dropdown>
        </ion-col>
    
        <ion-col size="3">
          <div class="d-flex justify-content-flex-end  align-items-center ">
            <div class="d-flex">
              <img (click)="downloadNineBoxPDF('Employee Wise Trends')" src="././assets/icon/downloadIcon.svg" alt="" class="cp">
            </div>
          </div>
        </ion-col>
      </ion-row>
    
      <div class="axis-container">
        <div class="y-axis-title">
          <span class="y-axis-text">Potential</span>
          <svg width="30" height="250">
            <line x1="15" y1="230" x2="15" y2="20" stroke="navy" stroke-width="3" />
            <polygon points="8,20 22,20 15,5" fill="navy" />
          </svg>
        </div>
    
        <div class="y-axis">
          <div class="y-axis-label">High</div>
          <div class="y-axis-label">Moderate</div>
          <div class="y-axis-label">Low</div>
        </div>
    
        <div class="d-flex flex-column">
          <div class="grid-container">
            <div class="cell" 
                 (click)="openEmployeeTooltip(cell)" 
                 *ngFor="let cell of arrPerformanceVsPotential" 
                 [ngClass]="cell.cssClass" 
                 [style.boxShadow]="'0 4px 6px rgba(0, 0, 0, 0.1)'"
                 [style.borderRadius]="'10px'"
                 [style.padding]="'20px'"
                 [style.height]="'130px'"
                 [style.transition]="'all 0.3s ease-in-out'"
                 [style.cursor]="'pointer'">
              
              <div class="score">{{ cell.count }}</div>
              <div class="description">{{ cell.category }}</div>
            </div>
          </div>
          
          <div class="x-axis">
            <div class="x-axis-label">Low</div>
            <div class="x-axis-label">Moderate</div>
            <div class="x-axis-label">High</div>
          </div>
    
          <div class="x-axis-title">
            <svg width="500" height="20">
              <line x1="10" y1="10" x2="480" y2="10" stroke="navy" stroke-width="3" />
              <polygon points="490,10 475,5 475,15" fill="navy" />
            </svg>
            <span>Performance</span>
          </div>
        </div>
      </div>
    </div>
    
  
    <!-- Employee Wise Trends -->

    <div class="card" style="margin-top: 20px;" *ngIf="bandNotFound && emptyDepartment == 1  && performancePotentialLength == 9" >
     <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
      <div class="graphs m-50">
        <ion-row class="justify-content-center">
          <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
            <h4 class="mt-20 ml-10 mb-10">Employee Wise Trends</h4>
          </ion-col>

          <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
            <div class="d-flex graph-icon">
              <span (click)="switchApprovedByFinanceGraph('bar')">
                <img *ngIf="isApprovedByFinanceIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                <img *ngIf="isApprovedByFinanceIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
              </span>
              <span (click)="switchApprovedByFinanceTable()">
                <img *ngIf="!isApprovedByFinanceTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                <img *ngIf="isApprovedByFinanceTable" src="././assets/icon/TableIconActive.svg" alt="">
              </span>
              <span (click)="switchApprovedByFinanceGraph('line')">
                <img *ngIf="isApprovedByFinanceIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt=""
                  class="cp">
                <img *ngIf="isApprovedByFinanceIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
              </span>
              <span>
                <img (click)="downloadChartAsPDF('Employee Wise Trends')" src="././assets/icon/downloadIcon.svg" alt=""
                  class="cp">
              </span>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
        <ion-col size="3">
       <ng-select class="w250 ml-10" placeholder="Select Employee"  [(ngModel)]="selectedGraphEmployee" [clearable]="false" (change)="selectedGraphEmployeeChange($event)">
          <ng-option [value]="item.userId"
                *ngFor="let item of arrEmployeesReport">{{item.name}}</ng-option>
            </ng-select>
        </ion-col>  
        </ion-row>
        
    <ion-row >
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" style="display: flex; justify-content: center;align-items: center; padding: 20px 0 20px 0;" >
        <div [ngClass]="{'dispNone' : !isApprovedByFinanceTable}">
          <div class="dashboardGraphTable"  >
            <table id="table-employee-wise-trends-data">
              <thead> 
                <tr class="custom-size" >
                  <th>year</th>
                  <th>Performance Score</th>
                  <th>Potential Score</th>
                
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of arrEmployeeWiseTrendsbyYear">
                  <td>{{data.xAxisValueData}}</td>
                  <td>{{data.seriesValueOneData}}</td>
                  <td>{{data.seriesValueTwoData}}</td>
                 
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div *ngIf="!isApprovedByFinanceTable" [ngClass]="{'dispNone' : isApprovedByFinanceTable}"  id="bar-line-chart-nine-box"
          style="width: 450px; height: 400px;">
        </div>
      </ion-col>
    </ion-row>

      </div>
    </ion-col>
    </div> 
</div>
 




